import {Component, inject} from '@angular/core';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-public',
    templateUrl: './public.component.html',
    styleUrl: './public.component.scss',
    imports: [RouterOutlet, RouterLink, NgIf, RouterLinkActive]
})
export class PublicComponent {

    router = inject(Router);

}
